export enum CustomFieldType {
	BOOLEAN = 'BOOLEAN',
	STRING = 'STRING',
	ENUM = 'ENUM',
}
